import { VFC } from "react";
import { NodeMap } from "src/types/node.types";
import { css } from "src/styles/theme";
import { CopyButton } from "./copy-button";
import { useGenerator } from "../hooks/use-generator.hook";
import type { CanvasPositionMap } from "src/features/editor";

export interface DataGeneratorProps {
  nodes: NodeMap;
  positions: CanvasPositionMap;
  hideCopyButton?: boolean;
}

export const DataGenerator: VFC<DataGeneratorProps> = ({
  nodes,
  positions,
  hideCopyButton,
}) => {
  const output = useGenerator(nodes, positions);

  return (
    <div className={$wrapper()}>
      <div className={$output()}>
        {output === "" && (
          <p className={$emptyMessage()}>Add some nodes to generate output</p>
        )}
        {output !== "" && <pre className={$code()}>{output}</pre>}
      </div>
      {!hideCopyButton && output !== "" && (
        <footer className={$footer()}>
          <CopyButton data={output} />
        </footer>
      )}
    </div>
  );
};

const $wrapper = css({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  position: "relative",
});

const $output = css({
  overflow: "auto",
  flexGrow: 1,
});

const $emptyMessage = css({
  minHeight: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "$4",
  color: "$neutral8",
});

const $code = css({
  display: "block",
  margin: 0,
  padding: "$6",
  fontSize: "$sm",
  fontFamily: "$mono",
  lineHeight: 1.5,

  "&::selection": {
    backgroundColor: "$primaryBg",
  },
});

const $footer = css({
  padding: "$6",
});
